export type DistrictSummary = {
  name: string;
  slug: string;
  placeCount: number;
};

export type CitySummary = {
  name: string;
  slug: string;
  placeCount: number;
  districts: DistrictSummary[];
};

export type LocationLabel = {
  city: string;
  districts: Map<string, string>;
};

export function createLocationLabels(
  cities: CitySummary[],
): Map<string, LocationLabel> {
  return new Map(
    cities.map((city) => [
      city.slug,
      {
        city: city.name,
        districts: new Map(
          city.districts.map((district) => [district.slug, district.name]),
        ),
      },
    ]),
  );
}

export function slugToLabel(slug: string): string {
  return slug
    .split('-')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

/** Places per city slug, from the actually loaded place list. */
export function cityCountsFrom(
  places: { citySlug: string }[],
): Map<string, number> {
  const counts = new Map<string, number>();
  for (const place of places) {
    counts.set(place.citySlug, (counts.get(place.citySlug) ?? 0) + 1);
  }
  return counts;
}
